export const curves = {
  default: "cubic-bezier(0.25, 0.1, 0.25, 1.0)",
  easeBoth: "cubic-bezier(.77,.25,0,.77)",
  linear: "cubic-bezier(0, 0, 1, 1)",
};
